module.exports = __webpack_public_path__ + "static/media/UNI-USDT.588d19dd.svg";